/* eslint-disable react/prop-types, require-jsdoc */
import React, { Fragment } from 'react';
import axios from 'axios';

import styled from 'styled-components';

import Styles from '../TicketsWhite/Tickets.styles';
import ValidateButton from '../TicketsWhite/ValidateButton';
import Text from '../../base/Text';

import InputsField from '../../base/InputsFieldFlat';

import UploadFileButton from './UploadFileButton';

import purpleArrow from '../../../assets/images/purple_arrow.png';

const Select = styled.select`${Styles.inputRounderSelect}`;
const Label = styled(Text).attrs({ bold: true })`${Styles.labelInput}`; // prettier-ignore
const ContentWrapperInputs = styled.div`${Styles.contentWrapperInputs}`; // prettier-ignore
const ButtonsContainer = styled.div`${Styles.buttonsContainer}`;
const LabelTop = styled(Text)`${Styles.labelTop}`; // prettier-ignore
const WarnLabel = styled(Text)`${Styles.warnLabel}`; // prettier-ignore


/**
* TicketInfo component
* @returns {JSX.Element}
*/
const AssistPassForm = ({
  translations,
  locale,
  assistPassName,
  assistPassLastName,
  assistPassGender,
  assistPassPhone,
  assistPassAge,
  assistPassDate,
  assistPassFightNumber,
  assistPassAirline,
  assistPassOrigin,
  assistPassDestination,
  assistPassTutorName,
  assistPassTutorLastName,
  assistPassTutorPhone,
  assistPassTutorEmail,
  assistPassTempId,
  changeAssistPassData,
  activeTicketType,
  assistPassNationality,
  destination,
  caption,
  submitFunction,
  hasContactInfo,
  insertContactInfo,
  flightDate
}) => {
  const freedomPayStyles = {
    borderRadius: '0.25rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    display: 'block',
    fontSize: '1rem',
    fontFamily: 'Arial, sans-serif',
    height: 'calc(2.25rem + 2px)',
    lineHeight: 1.5,
    padding: '0.375rem 0.75rem',
    backgroundColor: 'white',
    marginBottom: '1rem',
    width: '98%',
    marginLeft: '7px',
    outline: 'none',
  };
  const newFlightDate = assistPassDate || flightDate;
  const today = new Date().toISOString().substring(0, 10);

  const northbound = destination.place === 'San Diego';
  const southbound = destination.place === 'Tijuana';

  const permissionsRequiredSouthbound = southbound && assistPassNationality !== 'mex';
  const permissionsRequiredNorthboundOther = northbound && assistPassNationality !== 'other';
  const permissionsRequiredNorthbound = northbound && assistPassNationality !== 'mex';
  const permissionsRequiredNorthboundLessAmerican = northbound && assistPassNationality !== 'usa';
  const permissionsRequiredNorthboundAmerican = northbound && assistPassNationality === 'usa';

  const assistedDataOrigin = destination.place === 'Tijuana' ? 'TIJ-TJX' : assistPassOrigin;
  const assistedDataDestination = destination.place === 'San Diego' ? 'TIJ-TJX' : assistPassDestination;

  const UMNR_URLs = {
    'es': 'https://cbx-fe.s3.us-east-2.amazonaws.com/api/2023-04-19+-UMNR-+Decl.+Adulto+Responsable+Esp.pdf',
    'en': 'https://cbx-fe.s3.us-east-2.amazonaws.com/api/2023-04-19+-UMNR-+Responsible+Adult+Decl.+English.pdf'
  }

  const submitAssistPassForm = submitFunction || (() => {
    // eslint-disable-next-line no-new-object
    const cartAssistPassTicketInfo = new Object();
    // eslint-disable-next-line no-new-object
    const passengerInformation = new Object();
    // eslint-disable-next-line no-new-object
    const flightInformation = new Object();
    // eslint-disable-next-line no-new-object
    const tutorInformation = new Object();

    passengerInformation.firstName = assistPassName;
    passengerInformation.lastName = assistPassLastName;
    passengerInformation.gender = assistPassGender;
    passengerInformation.telephone = assistPassPhone;
    passengerInformation.nationality = assistPassNationality;
    passengerInformation.age = parseInt(assistPassAge, 10);
    flightInformation.date = newFlightDate;
    flightInformation.flightNumber = assistPassFightNumber;
    flightInformation.airline = assistPassAirline;
    flightInformation.origin = assistedDataOrigin;
    flightInformation.destination = assistedDataDestination;

    if (activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`) {
      tutorInformation.tutorFirstName = assistPassTutorName;
      tutorInformation.tutorLastName = assistPassTutorLastName;
      tutorInformation.tutorTelephone = assistPassTutorPhone;
      tutorInformation.tutorEmail = assistPassTutorEmail;
    }

    cartAssistPassTicketInfo.passengerInformation = passengerInformation;
    cartAssistPassTicketInfo.flightInformation = flightInformation;

    if (activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`) {
      cartAssistPassTicketInfo.tutorInformation = tutorInformation;
      cartAssistPassTicketInfo.tempFileId = assistPassTempId;
    }
    if (!hasContactInfo) {
      let contactInformation = {};
      if (activeTicketType === `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`) {
        contactInformation = {
          name: passengerInformation.firstName,
          lastName: passengerInformation.lastName,
          phone: passengerInformation.telephone
        };
      } else {
        contactInformation = {
          name: tutorInformation.tutorFirstName,
          lastName: tutorInformation.tutorLastName,
          phone: tutorInformation.tutorTelephone,
          email: tutorInformation.tutorEmail
        };
      }
      insertContactInfo(contactInformation);
    }
    window.localStorage.setItem('assisted_data', JSON.stringify(cartAssistPassTicketInfo));
    window.location.href = `/${locale}/configTicket`;
  });

  const validateEmail = (email) => {
    return email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
  };

  const validatePhone = (phone) => {
    return /^[+#*\\[\]]*([0-9]*){6,16}$/.test(phone) && phone.length >= 8 && phone.length <= 17;
  };

  const validateAge = (age, minAge, maxAge) => {
    if (age.length > 0) {
      if (!age.match(/^\d+$/)) return false;
      return age >= minAge && age <= maxAge;
    }
    return true;
  };


  const disabledAssistPassPhone = assistPassPhone.length > 0
    ? validatePhone(assistPassPhone)
    : true;
  const disabledAssistPassTutorPhone = activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && assistPassTutorPhone.length > 0
    ? validatePhone(assistPassTutorPhone)
    : true;
  const disabledAssistPassTutorEmail = activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`
  && assistPassTutorEmail.length > 0
    ? validateEmail(assistPassTutorEmail)
    : true;
  const disableAge = activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` ? validateAge(assistPassAge, 13, 17) : validateAge(assistPassAge, 0, 120);

  const disableContinueButton = !disabledAssistPassPhone || !disabledAssistPassTutorPhone || !disabledAssistPassTutorEmail || !disableAge;
  const AirlinesOptions = ['Aeromexico', 'Viva Aerobus', 'Calafia'];


  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex' }}>
        <div style={{
          backgroundColor: 'rgb(239, 96, 163)',
          width: '25px',
          height: '25px',
          borderRadius: 32,
          color: '#FFFFFF',
          paddingInline: '10px',
          paddingBottom: '8px',
          marginLeft: '20px',
          marginRight: '10px'
        }}
        >i
        </div>
        <div style={{ color: '#726C79', display: 'flex' }}>
          {translations.howWorks}
          { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`
            ? <a href={`/${locale}/unaccompanied-teen`} target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(239, 96, 163)', fontWeight: 'bold', marginLeft: '5px' }}>{translations.unaccompaniedTeen}</a>
            : <a href={`/${locale}/assisted-pass`} target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(239, 96, 163)', fontWeight: 'bold', marginLeft: '5px' }}>{translations.assistedPass}</a>}
          <div style={{ color: '#726C79', marginLeft: '5px' }}>
            {translations.works}
          </div>
        </div>
      </div>
      <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{
            marginInline: 'auto',
            cursor: 'pointer',
            paddingRight: '10px'
          }}
          src={purpleArrow}
        />{' '}
        {translations.passengerInformation}
      </Label>
      <Label
        color="#292033"
        size="15px"
        style={{
          width: '100%', fontWeight: 100, marginLeft: '10px', marginBottom: '2em'
        }}
      >
        {translations.assistedPassDescription}
      </Label>

      <ContentWrapperInputs style={{ width: '100%' }}>
        <Fragment>
          <InputsField
            placeHolder={translations.name.placeHolder}
            label={translations.name.label}
            name="name"
            className="col-12"
            status={1}
            labelOnTop
            value={assistPassName}
            onChange={value => changeAssistPassData('assistPassName', value)}
          />
          <InputsField
            placeHolder={translations.lastName.placeHolder}
            label={translations.lastName.label}
            className="col-12"
            name="lastName"
            status={1}
            labelOnTop
            value={assistPassLastName}
            onChange={value => changeAssistPassData('assistPassLastName', value)}
          />
          <div column>
            <LabelTop>{translations.assistPassGender}</LabelTop>
            <Select
              placeHolder={translations.assistPassGender}
              label={translations.assistPassGender}
              type="email"
              status={1}
              className="col-12"
              labelOnTop
              style={freedomPayStyles}
              value={assistPassGender}
              onChange={value => changeAssistPassData('assistPassGender', value)}
            >
              <option value="" key="Select">{translations.selectLabel}...</option>
              <option value="Male" key="Male">{translations.male}</option>
              <option value="Female" key="Female">{translations.female}</option>
              <option value="Unspecified" key="Unspecified">{translations.unspecified}</option>

            </Select>
            <WarnLabel style={{ color: 'black' }}>{translations.genderSelected}</WarnLabel>
          </div>
          <div column>
            <LabelTop>{translations.nationality}</LabelTop>
            <Select
              placeHolder={translations.nationality}
              label={translations.nationality}
              type="email"
              status={1}
              className="col-12"
              labelOnTop
              style={freedomPayStyles}
              value={assistPassNationality}
              onChange={value => changeAssistPassData('assistPassNationality', value)}
            >
              <option value="" key="Select">{translations.selectLabel}...</option>
              <option value="usa" key="usa">{translations.usa}</option>
              <option value="mex" key="mex">{translations.mex}</option>
              <option value="other" key="other">{translations.other}</option>

            </Select>
            <WarnLabel style={{ color: 'black' }} />
          </div>
          <InputsField
            placeHolder={translations.assistPassPhone}
            label={translations.assistPassPhone}
            type="tel"
            className="col-12"
            status={!disabledAssistPassPhone ? 2 : 1}
            labelOnTop
            value={assistPassPhone}
            onChange={(value) => {
              changeAssistPassData('assistPassPhone', value);
            }}
          />
          <div>
            <InputsField
              placeHolder={translations.assistPassAge}
              label={translations.assistPassAge}
              type="number"
              status={!disableAge ? 2 : 1}
              className="col-12"
              labelOnTop
              value={assistPassAge}
              min={activeTicketType === `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` ? 0 : 13}
              max={activeTicketType === `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` ? 120 : 17}
              onChange={value => changeAssistPassData('assistPassAge', value)}
              onKeyPress={(evt) => {
                const charCode = (typeof evt.which === 'undefined') ? evt.keyCode : evt.which;
                const charStr = String.fromCharCode(charCode);
                if (!charStr.match(/^[0-9]+$/)) evt.preventDefault();
              }}
            />

            { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`
            && <WarnLabel style={{ marginTop: '-1rem', color: 'black' }}>{translations.ageRangeunavailable}</WarnLabel>}

          </div>
        </Fragment>
      </ContentWrapperInputs>

      <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{
            marginInline: 'auto',
            cursor: 'pointer',
            paddingRight: '10px'
          }}
          src={purpleArrow}
        />{' '}
        {translations.flightDescription}
      </Label>

      <ContentWrapperInputs>
        <Fragment>
          <InputsField
            placeHolder={translations.assistPassDate}
            label={translations.assistPassDate}
            className="col-12"
            status={1}
            labelOnTop
            type="date"
            value={newFlightDate}
            min={today}
            onChange={value => changeAssistPassData('assistPassDate', value)}
          />
          <InputsField
            placeHolder={translations.assistPassFightNumber}
            label={translations.assistPassFightNumber}
            type="text"
            className="col-12"
            status={1}
            labelOnTop
            value={assistPassFightNumber}
            onChange={value => changeAssistPassData('assistPassFightNumber', value)}
          />
          <div column>
            <LabelTop>{translations.assistPassAirline}</LabelTop>
            <Select
              placeHolder={translations.assistPassAirline}
              label={translations.assistPassAirline}
              type="email"
              status={1}
              className="col-12"
              labelOnTop
              style={freedomPayStyles}
              value={assistPassAirline}
              onChange={value => changeAssistPassData('assistPassAirline', value)}
            >
              <option value="" key="Select">{translations.selectLabel}...</option>
              <option value="Volaris" key="Volaris">Volaris</option>
              { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && destination.place === 'San Diego' && AirlinesOptions.map(option => (
                <option value={option} key={`${option}`}>
                  {option}
                </option>
              ))}
              { activeTicketType === `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && AirlinesOptions.map(option => (
                <option value={option} key={`${option}`}>
                  {option}
                </option>
              ))}
            </Select>
            { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && destination.place === 'Tijuana' && (<WarnLabel>{translations.onlyVolaris}</WarnLabel>)}
          </div>
          <InputsField
            placeHolder={translations.assistPassOrigin}
            label={translations.assistPassOrigin}
            type="text"
            className="col-12"
            status={1}
            labelOnTop
            value={assistedDataOrigin}
            onChange={value => changeAssistPassData('assistPassOrigin', value)}
          />
          <InputsField
            placeHolder={translations.assistPassDestination}
            label={translations.assistPassDestination}
            type="text"
            className="col-12"
            status={1}
            labelOnTop
            value={assistedDataDestination}
            onChange={value => changeAssistPassData('assistPassDestination', value)}
          />
        </Fragment>
      </ContentWrapperInputs>
      { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && (
      <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{
            marginInline: 'auto',
            cursor: 'pointer',
            paddingRight: '10px'
          }}
          src={purpleArrow}
        />{' '}
        {translations.tutorDescription}
      </Label>
      )}
      { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && (
      <ContentWrapperInputs style={{ width: '100%' }}>
        <Fragment>
          <InputsField
            placeHolder={translations.name.placeHolder}
            label={translations.name.label}
            name={translations.name.label}
            className="col-12"
            isRequired={false}
            status={1}
            labelOnTop
            value={assistPassTutorName}
            onChange={value => changeAssistPassData('assistPassTutorName', value)}
          />
          <InputsField
            placeHolder={translations.lastName.placeHolder}
            label={translations.lastName.label}
            className="col-12"
            name={translations.lastName.label}
            status={1}
            labelOnTop
            value={assistPassTutorLastName}
            onChange={value => changeAssistPassData('assistPassTutorLastName', value)}
          />
          <InputsField
            placeHolder={translations.assistPassPhone}
            label={translations.assistPassPhone}
            type="tel"
            className="col-12"
            status={!disabledAssistPassTutorPhone ? 2 : 1}
            labelOnTop
            value={assistPassTutorPhone}
            onChange={value => changeAssistPassData('assistPassTutorPhone', value)}
          />
          <InputsField
            placeHolder={translations.assistPassTutorEmail}
            label={translations.assistPassTutorEmail}
            className="col-12"
            labelOnTop
            value={assistPassTutorEmail}
            onChange={value => changeAssistPassData('assistPassTutorEmail', value)}
            labelWarn={`${translations.email.label}${assistPassTutorEmail === 0 ? translations.isIncomplete : translations.isInvalid}`}
            type="email"
            name="assistPassTutorEmail"
            status={!disabledAssistPassTutorEmail ? 2 : 1}
          />
        </Fragment>
      </ContentWrapperInputs>
      )}
      { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && (
      <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{
            marginInline: 'auto',
            cursor: 'pointer',
            paddingRight: '10px'
          }}
          src={purpleArrow}
        />{' '}
        {translations.filesToSubmit}
      </Label>
      )}

      { activeTicketType !== `${process.env.GATSBY_BASE_ASSISTED_PASS_ID}` && (
        <ButtonsContainer style={{ flexDirection: 'column', marginBottom: '30px', marginTop:'15px' }}>
          <UploadFileButton name = {"UNMR_Form"} message={translations.unForm} translations={translations} assistPassTempId={assistPassTempId} linkName={translations.unFormSite} link={ UMNR_URLs[locale] || UMNR_URLs['en'] }/>
          {permissionsRequiredNorthboundLessAmerican && <UploadFileButton name = {"I94_Permit"} message={translations.permit94} translations={translations} assistPassTempId={assistPassTempId} linkName={translations.permit94Site} link={"https://i94.cbp.dhs.gov/I94/#/home"}/>}
          {permissionsRequiredNorthboundLessAmerican && permissionsRequiredNorthboundOther ? <UploadFileButton name = {"SAM_Form"} message={translations.samPermit} translations={translations} assistPassTempId={assistPassTempId} linkName={translations.samPermitSite} link={"https://www.inm.gob.mx/menores/publico/solicitud.html"} /> : ''}
          {permissionsRequiredNorthbound && <UploadFileButton name="Notarized_Letter" message={translations.notarizedPermit} translations={translations} /> }
          {permissionsRequiredSouthbound && <UploadFileButton name = {"FMM_Form"} message={translations.fmmPermit} translations={translations} assistPassTempId={assistPassTempId} linkName={translations.fmmPermitSite} link={"https://www.inm.gob.mx/fmme/publico/en/solicitud.html"}/>}
          <UploadFileButton name = {"Passport"} message={translations.passport} translations={translations} assistPassTempId={assistPassTempId}/>
          {permissionsRequiredNorthboundLessAmerican && <UploadFileButton name="Visa" message={translations.visa} translations={translations} />}
          {southbound && <UploadFileButton name="ID_Tutor" message={translations.IdTutor} translations={translations} />}
        </ButtonsContainer>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ButtonsContainer style={{ marginBottom: 50, marginTop: 15 }}>
          <ValidateButton
            action={() => { window.location.href = `/${locale}/`; }}
            message={caption || translations.return}
            marginTop={35}
            backgroundColor="#3F2A55"
          />
        </ButtonsContainer>


        <ButtonsContainer style={{ marginBottom: 50, marginTop: 15 }}>
          <ValidateButton
            action={submitAssistPassForm}
            message={caption || translations.proceedCheckout}
            marginTop={35}
            disabled={disableContinueButton}
          />
        </ButtonsContainer>
      </div>
    </div>
  );
};


export default AssistPassForm;
